<template>
  <div
    :class="['container', _isMobile() ? 'mobile' : '']"
    :style="{
      background: tenantConfig.homeBgColor,
      'background-image': 'url(' + tenantConfig.homeBg + ')',
      'background-repeat': tenantConfig.homeBgRepeat,
    }"
  >
    <Header id="header"/>
    <div :class="['student-container', _isMobile() ? 'no-padding' : '']">
      <a-layout>
        <a-row>
          <a-col :xs="0" :sm="0" :md="4" :lg="4" :xl="4" :xxl="4">
            <!-- <a-layout-sider> -->
              <SideMenuStudent class="side-menu" />
            <!-- </a-layout-sider> -->
          </a-col>
          <a-col :xs="23" :sm="23" :md="19" :lg="19" :xl="19" :xxl="19" :offset="1">
            <!-- <a-layout-content> -->
              <a-card :bordered="false">
                <router-view />
              </a-card>
            <!-- </a-layout-content> -->
          </a-col>
        </a-row>
      </a-layout>
    </div>
    <Footer />
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG, ACCESS_TOKEN } from "@/store/mutation-types";
import { mixinDevice } from "@/utils/mixin.js";
import SideMenuStudent from "../components/SideMenuStudent.vue";
import Header from "@/components/header/HeaderWayi";
import Header2 from "@/components/header/Header2";
import Header3 from "@/components/header/Header3";
import Footer from "@/components/footer/Footer";
import { jumpMixins } from "@/utils/jumpMixins";

export default {
  name: "HomeLayout",
  mixins: [mixinDevice, jumpMixins],
  components: {
    Header,
    Header2,
    Header3,
    SideMenuStudent,
    Footer,
  },
  data() {
    return {
      tenantConfig: {},
    };
  },
  created() {
    if (!Vue.ls.get(ACCESS_TOKEN)) {
      this.toLogin();
    }
    this.tenantConfig = this.$store.getters.tenantInfo;
  },
};
</script>

<style lang="less" scoped>
.container {
  // min-height: 100vh;
  background: #f2f6f8;
  background: url(/assets/background.svg);
  .student-container {
    max-width: 1200px;
    margin: 10px auto;
    padding: 20px 30px;
    background: #ffffffd1;
    border-radius: 30px;
  }
  .no-padding {
    padding: 0 !important;
  }
  .ant-layout {
    background: transparent;
  }
  .ant-layout-sider {
    background: transparent;
  }
  .side-menu {
    background: #fff;
    text-align: center;
    border-radius: 10px;
  }
  .ant-card {
    margin: 0 20px;
    background: #fff;
  }
}
</style>